<div mat-dialog-title class="flex flex-row">
  Abertura de Ocorrência
  <div class="flex-fill"></div>
  <div class="btn-options">
    <button
      color="primary"
      (click)="dialogRef.close()"
      mat-icon-button
      matTooltip="Fechar"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div mat-dialog-content>
  <div class="loading-shade" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
  </div>
  <div *ngIf="!error; else errorTemplate">
    <form [formGroup]="form">
      <div class="grid--auto-fill">
        <mat-form-field>
          <mat-label>Assunto Ocorrencia</mat-label>
          <input appTitlecase formControlName="assunto" matInput />
          <mat-error>Informação necessária</mat-error>
        </mat-form-field>
      </div>
      <div class="flex form-registro mt-1">
        <mat-form-field class="flex-fill">
          <mat-label>Mensagem</mat-label>
          <textarea formControlName="mensagem" matInput ></textarea>
        </mat-form-field>
      </div>
    </form>
    <mat-card-actions>
      <div *ngIf="!isLoadingResults" class="flex">
        <div class="flex-fill"></div>
        <div>
          <button
            mat-raised-button
            color="primary"
            (click)="salvarData()"
            [disabled]="disableButton"
            cdkFocusInitial
          >
            Salvar
          </button>
        </div>
      </div>
    </mat-card-actions>
  </div>
</div>

<ng-template #errorTemplate>
  <app-server-error></app-server-error>
</ng-template>

<ng-template #loading>
  <mat-spinner [diameter]="25"></mat-spinner>
</ng-template>
